import { useQuery } from 'react-query';
import { storeClient, endpoints } from '../api/client';

export interface CurrencyOption {
  code: string;
  name: string;
}

async function fetchCurrencies(): Promise<CurrencyOption[]> {
  const response = await storeClient.get<Record<string, string>>(endpoints.storeCurrencies);
  const map = response.data;
  if (!map || typeof map !== 'object') return [];
  return Object.entries(map)
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Fetches the list of available currencies from the store service.
 * The endpoint is public (no auth required) so this can be called early.
 */
export const useCurrencies = () => {
  return useQuery<CurrencyOption[]>(
    'storeCurrencies',
    fetchCurrencies,
    {
      staleTime: 30 * 60 * 1000,
      retry: 2,
    }
  );
};
